<template>
  <div class="home">
    <!-- 头 -->
    <div class="top">
      <div class="header" :class="{ 'is-stack-btns': stackBtns }">
        <div class="header-left">
          <img src="@/assets/images/编组 3@2x.png" alt="" class="hand-cursor" @click="clickHome"/>
        </div>
        <div class="header-center">
          <span
            v-for="(item, i) in navMenuData.navMenuData"
            :key="i"
            class="hand-cursor hover-red text-span"
            :class="{ 'active-text': activeIndex === i }"
            @click="clickBtn(item, i)"
          >
            <span class="tab-label">{{ item }}</span>
          </span>
        </div>
        <div class="header-right">
          <!-- <div @click="addCompanyBtn" class="hand-cursor">提交企业信息</div>
          <div @click="addExpertBtn" class="hand-cursor">新增专家库</div> -->
          <el-button type="primary" @click="addCompanyBtn" plain>企业信息申请</el-button>
          <el-button type="primary" @click="addExpertBtn" plain>专家库申请</el-button>
        </div>
        <button type="button" class="gs-menu-btn" :class="{ open: menuOpen }" @click="menuOpen = !menuOpen" aria-label="菜单">
          <span></span><span></span><span></span>
        </button>
      </div>
      <div class="header-drawer" v-show="menuOpen">
        <span
          v-for="(item, i) in navMenuData.navMenuData"
          :key="'m-'+i"
          class="drawer-link"
          :class="{ 'active-text': activeIndex === i }"
          @click="clickBtn(item, i)"
        ><span class="tab-label">{{ item }}</span></span>
        <div class="drawer-actions">
          <el-button type="primary" @click="addCompanyBtn" plain>企业信息申请</el-button>
          <el-button type="primary" @click="addExpertBtn">专家库申请</el-button>
        </div>
      </div>
    </div>
    <!-- <AddExpert 
      :open-expert="openExpert"
      @closeExpert="closeExpert"
    />
    <AddCompanyInfo 
      :openCompanyInfo="openCompanyInfo"
      @closeCompany="closeCompany"
    /> -->
  </div>
</template>

<script>
import navMenuData from "@/utils/mock.js";
import { P } from '@/router/paths';
export default {
  name: "Home",
  data() {
    return {
      activeIndex: -1,
      navMenuData: [],
      openExpert: false,
      openCompanyInfo: false,
      menuOpen: false,
      stackBtns: false
    };
  },
  mounted() {
    this.fitHeader()
    this._onFitHeader = () => this.fitHeader()
    window.addEventListener('resize', this._onFitHeader)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._onFitHeader)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onFitHeader)
  },
  created() {
    this.navMenuData = navMenuData;
    this.syncActive();
  },
  watch: {
    '$route.path'() {
      this.syncActive();
      this.menuOpen = false;
    }
  },
  methods: {
    fitHeader() {
      if (window.innerWidth <= 960) {
        this.stackBtns = false
        return
      }
      this.stackBtns = false
      this.$nextTick(() => {
        const header = this.$el && this.$el.querySelector('.header')
        const center = this.$el && this.$el.querySelector('.header-center')
        if (!header || !center) return
        const overflow = header.scrollWidth > header.clientWidth + 1
        const tabsWrapped = center.scrollHeight > 42
        if (overflow || tabsWrapped) {
          this.stackBtns = true
        }
      })
    },
    syncActive() {
      const path = this.$route.path
      const map = [
        { test: (p) => p === '/' || p === '/Home', label: '首页' },
        { test: (p) => p === '/enterprises', label: '企业资料' },
        { test: (p) => p.startsWith('/hall'), label: '数据交易大厅' },
        { test: (p) => p.startsWith('/map'), label: '数据地图' },
        { test: (p) => p.startsWith('/providers') || p.startsWith('/supplier'), label: '数据服务商' },
        { test: (p) => p.startsWith('/resources'), label: '数据资源' },
        { test: (p) => p.startsWith('/datasets'), label: '数据集' },
        { test: (p) => p.startsWith('/college'), label: '数据资产商学院' },
        { test: (p) => p.startsWith('/lab'), label: '国数探索实验室' }
      ]
      const hit = map.find((item) => item.test(path))
      const label = hit ? hit.label : ''
      const list = (this.navMenuData && this.navMenuData.navMenuData) || []
      this.activeIndex = label ? list.indexOf(label) : (path === '/Home' ? 0 : -1)
    },
    clickHome() {
      this.activeIndex = 0
      this.menuOpen = false
      if(this.$route.path!== P.home) {
        this.$router.push(P.home)
      }
    },
    addCompanyBtn() {
      this.$router.push(P.submitCompany)
    },
    addExpertBtn() {
      this.$router.push(P.submitExpert)
    },
    closeExpert(data) {
      this.openExpert = data
    },
    closeCompany(data) {
      this.openCompanyInfo = data
    },
    clickBtn(item, index) {
      this.activeIndex = index
      this.menuOpen = false
      const table = {
        '首页': P.home,
        '企业资料': P.enterprises,
        '数据交易大厅': P.hall,
        '数据地图': P.map,
        '数据服务商': P.providers,
        '数据资源': P.resources,
        '数据集': P.datasets,
        '数据资产商学院': P.college,
        '国数探索实验室': P.lab
      }
      const path = table[item]
      if (path) this.$router.push(path).catch(() => false)
    }
  }
};
</script>
<style scoped lang="less">
// @media screen and (max-width: 600px) {
//   // .home {
//   //   width: 650PX;
//   // }
//   .top {
//     padding: 0 !important;
//   }
//   .header-right {
//     flex-direction: column;
//   }
//   .header-left {
//     margin-right: 1PX !important;
//   }
//   .header-left img {
//     height: 40px !important;
//     width: 150px !important;
//   }
// }
.home {
  width: 100%;
  .top {
    background-image: url('@/assets/images/矩形.png');
    background-size: 100% 100%;
    width: 100%;
    padding: 0 28px;
    top: 0;
    min-height: 72px;
    height: auto;
    position: relative;
    box-sizing: border-box;
    .header {
      color: #fff;
      font-size: 16px;
      min-height: 72px;
      width: 100%;
      max-width: none;
      display: flex;
      flex-wrap: nowrap;
      font-family: AlibabaPuHuiTi_3_55_Regular;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      padding-top: 12px;
      padding-bottom: 10px;
      box-sizing: border-box;
      .header-center {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
      }
      .text-span {
        flex: 0 0 auto;
        min-width: 0;
        height: auto;
        line-height: 1.35;
        padding: 6px 0;
        text-align: center;
        font-style: normal;
        opacity: .8;
        white-space: nowrap;
        text-decoration: none;
      }
      .tab-label {
        text-decoration: none;
        text-decoration-color: #fff;
        text-decoration-thickness: 2px;
        text-underline-offset: 3px;
        text-underline-position: under;
      }
      .text-span:hover {
        color: #FFFFFF;
        opacity: 1;
      }
      .active-text {
        color: #FFFFFF;
        opacity: 1;
      }
      .active-text .tab-label {
        text-decoration: underline;
      }
      .header-left{
        flex: 0 0 auto;
        margin: 0;
        img  {
          height: 32px;
          width: 160px;
        }
      }
      .header-right {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        flex: 0 0 auto;
        gap: 8px;
        margin: 0;
        button {
          width: 112px;
          height: 28px;
          font-size: 13px;
          padding: 0 8px;
          border-radius: 50px;
          margin: 0;
        }
        :deep(.el-button + .el-button) {
          margin-left: 0;
        }
      }
      &.is-stack-btns .header-right {
        flex-direction: column;
        gap: 6px;
      }
      .gs-menu-btn {
        display: none;
        width: 36px;
        height: 36px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 5px;
        background: transparent;
        border: 0;
        padding: 0;
        cursor: pointer;
        span {
          display: block;
          width: 20px;
          height: 2px;
          background: #fff;
        }
        &.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        &.open span:nth-child(2) { opacity: 0; }
        &.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }
      }
    }
    .header-drawer {
      display: none;
      flex-direction: column;
      position: absolute;
      left: 0;
      right: 0;
      top: 44px;
      z-index: 20;
      padding: 6px 14px 12px;
      background: #0b2a6b;
      .drawer-link {
        color: #fff;
        padding: 10px 4px;
        font-size: 14px;
        border-bottom: 1px solid rgba(255,255,255,.12);
      }
      .drawer-actions {
        display: flex;
        gap: 8px;
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 960px) {
  .home .top {
    height: auto;
    min-height: 44px;
    padding: 0 12px;
    .header {
      height: 44px;
      min-height: 44px;
      gap: 10px;
      padding-top: 0;
      padding-bottom: 0;
      .header-center,
      .header-right { display: none; }
      .header-left img {
        height: 22px;
        width: 110px;
      }
      .gs-menu-btn {
        display: flex;
        width: 32px;
        height: 32px;
        gap: 4px;
        span { width: 18px; }
        &.open span:nth-child(1) { transform: translateY(6px) rotate(45deg); }
        &.open span:nth-child(3) { transform: translateY(-6px) rotate(-45deg); }
      }
    }
    .header-drawer { display: flex; }
  }
}
</style>
